import React, { useState, useEffect } from 'react';
import { Modal, Row, Col, Upload, notification } from 'antd';
import { useTranslation } from 'react-i18next';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { FILE_TEMPLATE_CODE } from 'helpers/constants';
import { excelFileUpload, downloadTemplateFile } from 'store/requests/definitions';

const ActivePassiveUpdate = ({
  onCloseHandler,
  activePassiveExcelUrl,
  isCourier,
}) => {
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [openImportModal, setOpenImportModal] = useState(false);

  useEffect(() => {
    showInfo();
  }, []);

  const props = {
    name: 'file',
    maxCount: 1,
    headers: {
      authorization: 'authorization-text',
    },
    beforeUpload: (file) => {
      const isExcel =
        file.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || // .xlsx
        file.type === 'application/vnd.ms-excel'; // .xls

      if (!isExcel) {
        notification.error({ message: t('onlyAcceptExcel') });
        return false;
      }

      setFile(file);
      return false;
    },
  };

  const handleSubmit = async () => {
    if (!file) {
      notification.error({ message: t('selectFile') });
      return;
    }

    setIsSubmitting(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append(
      'templateCode',
      isCourier
        ? FILE_TEMPLATE_CODE.COURIER_ACTIVE_PASSIVE
        : FILE_TEMPLATE_CODE.USER_ACTIVE_PASSIVE,
    );

    try {
      const res = await excelFileUpload(formData);
      if (res.error) {
        notification.error({ message: res.message });
      } else {
        notification.success({ message: t('fileUploadSuccess') });
      }
    } catch (error) {
      notification.error({ message: t('fileUploadError') });
    } finally {
      setIsSubmitting(false);
      setOpenImportModal(false);
      onCloseHandler();
    }
  };

  const handleDownload = () => {
    downloadTemplateFile(activePassiveExcelUrl);
  };

  const showInfo = () => {
    Modal.info({
      title: t('bulkActivePassiveUpdate'),
      content: (
        <div>
          <p>{t('infoForBulkActivePassiveUpdate')}</p>
        </div>
      ),
      onOk() {
        setOpenImportModal(true);
      },
    });
  };

  return (
    <>
      <Modal
        open={openImportModal}
        maskClosable={false}
        onOk={handleSubmit}
        okButtonProps={{ loading: isSubmitting, disabled: !file }}
        onCancel={onCloseHandler}
        title={t('bulkActivePassiveUpdate')}
        okText={t('save')}
        cancelText={t('cancel')}
        width={600}
      >
        <Row>
          <Col
            span={12}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <div
              onClick={handleDownload}
              style={{
                width: '102px',
                height: '102px',
                borderStyle: 'solid',
                borderWidth: '1px',
                borderColor: 'lightgrey',
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '1px',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <DownloadOutlined />
              </div>
              <div>
                <p style={{ margin: '5px', textAlign: 'center' }}>
                  {t('downloadExampleTemplate')}
                </p>
              </div>
            </div>
          </Col>
          <Col
            span={12}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <Upload {...props}>
              <div
                style={{
                  width: '102px',
                  height: '102px',
                  borderStyle: 'solid',
                  borderWidth: '1px',
                  borderColor: 'lightgrey',
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '1px',
                  cursor: 'pointer',
                }}
              >
                <UploadOutlined />
                <p>{t('uploadReadyTemplate')}</p>
              </div>
            </Upload>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default ActivePassiveUpdate;
